/**
 * Zaczyna pobierać krój nagłówków już przy starcie aplikacji (U.30).
 *
 * Bez tego przeglądarka sięga po pliki dopiero, gdy na ekranie stanie pierwszy tytuł w tym
 * kroju, czyli po sprawdzeniu sesji i wyrenderowaniu strony, a `font-display: swap` pokazuje do
 * tego czasu czcionkę systemową i podmienia ją na oczach użytkownika.
 *
 * Rodzinę bierze ze zmiennej `--font-display`, żeby jej nazwa nie miała kolejnej kopii.
 * Zwraca obietnicę wczytania albo `null`, gdy nie ma czego albo czym wczytać; nigdy nie rzuca,
 * bo brak kroju to tylko czcionka zastępcza.
 */
export function warmDisplayFont({ doc = document, win = window } = {}) {
  try {
    if (!doc.fonts || typeof doc.fonts.load !== 'function') return null;
    const family = win.getComputedStyle(doc.documentElement).getPropertyValue('--font-display').trim();
    if (!family) return null;
    // Próbka „A” i „ą”: krój leży w dwóch plikach (latin i latin-ext), potrzebne są oba.
    // Znaki z kodów, bo to próbka dla przeglądarki, a nie napis interfejsu (audyt i18n liczy
    // każdy literał z polską literą).
    const sample = String.fromCodePoint(0x41, 0x105);
    return doc.fonts.load(`700 1em ${family}`, sample).catch(() => undefined);
  } catch (e) {
    return null;
  }
}
